// "use client";

// import React, { useEffect } from "react";

// const MaintenancePage = () => {
//   useEffect(() => {
//     const enabled = process.env.NEXT_PUBLIC_MAINTENANCE_NOTIFICATION_ENABLED === 'true';
    
//     if (enabled) {
//       fetch("https://api.rawento.com/api/tracking/maintenance", {
//         method: 'GET',
//         keepalive: true,
//       }).catch(console.error);
//     }
//   }, []);

//   return (
//     <>
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "flex-start",
//           alignItems: "center",
//           backgroundColor: "#f2f4f8",
//           color: "#333",
//           textAlign: "center",
//           padding: "60px 20px 20px 20px",
//           boxSizing: "border-box",
//         }}
//       >
//         <img
//           src="https://rawento.com/static/img/logo.png"
//           alt="Shop Logo"
//           style={{
//             maxWidth: "240px",
//             height: "auto",
//             marginBottom: "40px",
//             filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.25))",
//             borderRadius: "10px",
//           }}
//         />
//         <h1 style={{ fontSize: "3rem", marginBottom: "18px" }}>
//           Wartungsmodus
//         </h1>
//         <p
//           style={{
//             fontSize: "1.4rem",
//             color: "#555",
//             maxWidth: "480px",
//             marginBottom: "40px",
//             lineHeight: "1.6",
//           }}
//         >
//           Unsere Seite ist derzeit im Wartungsmodus. Bitte versuche es später erneut.
//           Vielen Dank für dein Verständnis!
//         </p>
//         <a
//           href="mailto:info@rawento.com"
//           style={{
//             width: "100%",
//             maxWidth: "300px",
//             padding: "12px",
//             backgroundColor: "#333",
//             color: "white",
//             border: "none",
//             fontSize: "16px",
//             cursor: "pointer",
//             borderRadius: "4px",
//             textAlign: "center",
//             marginTop: "10px",
//             display: "inline-block",
//             transition: "background-color 0.3s",
//             textDecoration: "none",
//           }}
//           onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#555")}
//           onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#333")}
//         >
//           Kontakt aufnehmen
//         </a>
//       </div>
//     </>
//   );
// };

// export default MaintenancePage;


"use client";

import React, { useEffect } from "react";

const MaintenancePage = () => {
  useEffect(() => {
    const enabled = process.env.NEXT_PUBLIC_MAINTENANCE_NOTIFICATION_ENABLED === 'true';
    
    if (enabled) {
      fetch("https://api.rawento.com/api/tracking/maintenance", {
        method: 'GET',
        keepalive: true,
      }).catch(console.error);
    }
  }, []);

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          backgroundColor: "#f2f4f8",
          color: "#333",
          textAlign: "center",
          padding: "60px 20px 20px 20px",
          boxSizing: "border-box",
        }}
      >
        <img
          src="https://rawento.com/static/img/logo.png"
          alt="Shop Logo"
          style={{
            maxWidth: "240px",
            height: "auto",
            marginBottom: "40px",
            filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.25))",
            borderRadius: "10px",
          }}
        />
        <h1 style={{ fontSize: "3rem", marginBottom: "18px" }}>
          Wartungsmodus
        </h1>
        <p
          style={{
            fontSize: "1.4rem",
            color: "#555",
            maxWidth: "480px",
            marginBottom: "40px",
            lineHeight: "1.6",
          }}
        >
          Unsere Seite ist derzeit im Wartungsmodus. Bitte versuchen Sie es später erneut.
          Vielen Dank für Ihr Verständnis!
        </p>
        <a
          href="mailto:info@rawento.com"
          style={{
            width: "100%",
            maxWidth: "300px",
            padding: "12px",
            backgroundColor: "#333",
            color: "white",
            border: "none",
            fontSize: "16px",
            cursor: "pointer",
            borderRadius: "4px",
            textAlign: "center",
            marginTop: "10px",
            display: "inline-block",
            transition: "background-color 0.3s",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#555")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#333")}
        >
          Kontakt aufnehmen
        </a>
      </div>
    </>
  );
};

export default MaintenancePage;